<template>
  <div class="auth__container">
    <loader-spinner v-if="isLoadingGlobalInfo" />
    <div v-else>
      <h2>Sign into Fiduciary Connect</h2>
      <p>A platform that helps you manage funds, lineups, and product universes.</p>
      <form class="mds-form mds-form--large-layout" method="post" action="">
        <fieldset class="mds-form__fieldset">
          <div class="mds-form__field-group">
            <label class="mds-form__label" for="username">
              Username
              <abbr
                class="mds-form__label-required-indicator"
                title="This field is required."
                aria-hidden="true"
                >*</abbr
              >
              <span class="mds-form__label-required-indicator-label">Required Field.</span>
            </label>
            <input class="mds-form__input" type="text" id="username" ref="username" />
          </div>
          <div class="mds-form__field-group">
            <label class="mds-form__label" for="password">
              Password
              <abbr
                class="mds-form__label-required-indicator"
                title="This field is required."
                aria-hidden="true"
                >*</abbr
              >
              <span class="mds-form__label-required-indicator-label">Required Field.</span>
            </label>
            <input class="mds-form__input" type="password" id="password" ref="password" />
          </div>
          <div class="mds-form__field-group" v-if="showForgotPasswordLink">
            <button
              class="mds-link mds-button mds-button--flat fc-flat-button__forgot-password"
              @click="jumpTo('forgot-password')"
            >
              Forgot Your Password?
            </button>
          </div>
        </fieldset>
        <div class="mds-form__field-group">
          <button
            class="mds-button mds-button--primary fc-button__sign-in"
            type="button"
            @click="secureLogin"
          >
            Sign In
          </button>
        </div>
        <loader-spinner v-if="loading" />
      </form>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex';

import { goToRoute } from '@/utils';
import AuthMixin from '@/mixins/AuthMixin';
import reCaptchaMixin from '@/mixins/ReCaptchaMixin';
import LoaderSpinner from '@/components/atoms/LoadingSpinner';

export default {
  name: 'auth',
  mixins: [AuthMixin, reCaptchaMixin()],
  components: {
    LoaderSpinner,
  },
  data() {
    return {
      errorType: null,
      loading: false,
    };
  },
  created() {
    if (this.hasAccessToBrowseIn) {
      goToRoute(this.$route, this.$router, '/');
    } else {
      this.signout();
    }
  },
  methods: {
    ...mapActions({
      logError: 'logError',
    }),
    async secureLogin() {
      /**
       * @var response
       * {
       *  result: boolean
       *  token: String
       * }
       */
      const response = await this.reCaptcha();
      if (response && response.validBehavior) {
        return this.login();
      }
      return null;
    },
    jumpTo(step) {
      this.$emit('jumpTo', step);
    },
  },
  computed: {
    ...mapState({
      isLoadingGlobalInfo: (state) => state.system.isLoading,
    }),
    ...mapGetters({
      hasAccessToBrowseIn: 'user/hasAccessToBrowseIn',
    }),
    showForgotPasswordLink() {
      return process.env.VUE_APP_SHOW_FORGOT_PASSWORD_LINK === 'true';
    },
  },
};
</script>
